var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChampagne(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9091 8.18164H4.09088C3.68178 8.18164 3.40906 8.45437 3.40906 8.86346V12.9544V17.7271C3.40906 19.7725 4.90906 21.4089 6.81815 21.7498V27.2726C6.81815 28.0226 6.20451 28.6362 5.45451 28.6362C5.04542 28.6362 4.77269 28.9089 4.77269 29.318C4.77269 29.7271 5.04542 29.9998 5.45451 29.9998H9.54542C9.95451 29.9998 10.2272 29.7271 10.2272 29.318C10.2272 28.9089 9.95451 28.6362 9.54542 28.6362C8.79542 28.6362 8.18179 28.0226 8.18179 27.2726V21.7498C10.0909 21.4089 11.5909 19.7725 11.5909 17.7271V12.9544C11.5909 12.5453 11.3181 12.2725 10.9091 12.2725H6.81815C6.40906 12.2725 6.13633 12.5453 6.13633 12.9544C6.13633 13.3635 6.40906 13.6362 6.81815 13.6362H10.2272V17.7271C10.2272 19.2271 8.99997 20.4544 7.49997 20.4544C5.99997 20.4544 4.77269 19.2271 4.77269 17.7271V12.9544V9.54528H10.2272V10.2271C10.2272 10.6362 10.5 10.9089 10.9091 10.9089C11.3181 10.9089 11.5909 10.6362 11.5909 10.2271V8.86346C11.5909 8.45437 11.3181 8.18164 10.9091 8.18164Z",
    fill: "url(#paint0_linear_2146_13175)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 17.7266C15.9545 17.7266 15.6818 17.9993 15.6818 18.4084V23.8629C15.6818 24.272 15.9545 24.5447 16.3636 24.5447H23.1818C23.5909 24.5447 23.8636 24.272 23.8636 23.8629V18.4084C23.8636 17.9993 23.5909 17.7266 23.1818 17.7266H16.3636ZM22.4999 23.1811H17.0454V19.0902H22.4999V23.1811Z",
    fill: "url(#paint1_linear_2146_13175)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4091 21.8187H21.1364C21.5455 21.8187 21.8182 21.546 21.8182 21.1369C21.8182 20.7278 21.5455 20.4551 21.1364 20.4551H18.4091C18 20.4551 17.7273 20.7278 17.7273 21.1369C17.7273 21.546 18 21.8187 18.4091 21.8187Z",
    fill: "url(#paint2_linear_2146_13175)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0226 14.0455C24.8863 13.7045 24.4772 13.5682 24.1363 13.7045C23.7954 13.8409 23.659 14.25 23.7954 14.5909C24.7499 16.7045 25.2954 19.0227 25.2954 21.2727V27.9545C25.2954 28.3636 25.0226 28.6364 24.6136 28.6364H14.9999C14.5908 28.6364 14.3181 28.3636 14.3181 27.9545V21.3409C14.3181 18.6818 14.9999 16.0227 16.2954 13.6364C17.659 11.1136 18.409 8.18182 18.409 5.31818V4.09091H21.1363V5.25C21.1363 7.15909 21.4772 9.06818 22.0908 10.9091H19.0908C18.6817 10.9091 18.409 11.1818 18.409 11.5909C18.409 12 18.6817 12.2727 19.0908 12.2727H23.0454C23.2499 12.2727 23.4545 12.1364 23.5908 12C23.7272 11.7955 23.7272 11.5909 23.659 11.3864C22.8408 9.47727 22.4999 7.43182 22.4999 5.31818V0.681818C22.4999 0.272727 22.2272 0 21.8181 0H17.7272C17.3181 0 17.0454 0.272727 17.0454 0.681818V5.25C17.0454 7.90909 16.3636 10.5682 15.0681 12.9545C13.7045 15.4773 12.9545 18.4091 12.9545 21.2727V27.9545C12.9545 29.1136 13.8408 30 14.9999 30H24.5454C25.7045 30 26.5908 29.1136 26.5908 27.9545V21.3409C26.5908 18.8182 26.0454 16.2955 25.0226 14.0455ZM18.409 1.36364H21.1363V2.72727H18.409V1.36364Z",
    fill: "url(#paint3_linear_2146_13175)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2146_13175",
    x1: 7.49997,
    y1: 8.18164,
    x2: 7.49997,
    y2: 29.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2146_13175",
    x1: 19.7727,
    y1: 17.7266,
    x2: 19.7727,
    y2: 24.5447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2146_13175",
    x1: 19.7727,
    y1: 20.4551,
    x2: 19.7727,
    y2: 21.8187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2146_13175",
    x1: 19.7726,
    y1: 0,
    x2: 19.7726,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#78264F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B2F68"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChampagne);
export default __webpack_public_path__ + "static/media/champagne.a2173398.svg";
export { ForwardRef as ReactComponent };